import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IUser } from "../../models/user.model";
import * as authActions from '../actions/auth.actions';
import { MainModule } from "./main.reducer";

export type Actions = authActions.All;

export interface AuthState {
  isLoggedIn: boolean,
  user: IUser,
  loading?: boolean,
  uidTrack?: string
}

export const initialState: AuthState = {
  user: null,
  isLoggedIn: false,
  loading: false,
}

export function authReducer(state: AuthState = initialState, action: Actions) {
  switch (action.type) {
    case authActions.SIGN_UP:
    case authActions.VERIFY_AUTH:
    case authActions.LOGIN_SOCIAL_CUSTOM:
    case authActions.LOGIN_EMAIL_CUSTOM:
    case authActions.LOGOUT:
    case authActions.UPDATE_PROFILE:
    case authActions.CHANGE_AVATAR:
    case authActions.LOGIN_RESTORE_PASSWORD:
    case authActions.LOGIN_TOKEN_CUSTOM:
      return { ...state, loading: true };
    case authActions.SIGN_UP_SUCCESS:
    case authActions.AUTHENTICATED:
    case authActions.LOGIN_SUCCESS:
    case authActions.UPDATE_PROFILE_SUCCESS:
      return { ...state, loading: false, user: action.payload, isLoggedIn: true };
    case authActions.SIGN_UP_FAILED:
    case authActions.LOGIN_FAILED:
      return initialState;
    case authActions.UPDATE_PROFILE_FAILED:
      return { ...state, loading: false, isLoggedIn: true };
    case authActions.NOT_AUTHENTICATED:
      return initialState;
    default:
      return state;
  }
}

export const getAuthModule = createFeatureSelector<MainModule>('mainModule');
export const getAuthState = createSelector(getAuthModule, (state: MainModule) => state.authState);
export const getUser = createSelector(getAuthState, (state: AuthState) => state.user);
export const getIsLoggeIn = createSelector(getAuthModule, (state: MainModule) => state.authState.isLoggedIn);
export const getUidTrack = createSelector(getAuthModule, (state: MainModule) => state.authState.uidTrack);



// WEBPACK FOOTER //
// ./src/ngrx/reducers/auth.reducer.ts